import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectLandingState } from './selectLandingState'

export const selectIsFetchLoading = createSelector(
  [selectLandingState],
  ({ fetchStatus }) => fetchStatus === RequestStatus.PENDING
)
